<template>

  <t-form-wrapped v-if="address !== null" :command="command" :status="status">

    <div>

      <b-row>

        <t-input cols="2" v-model="address.zipcode" label="CEP" cep api @get="setAddress" :required="!notRequired"/>
        <t-input cols="6" v-model="address.street" label="Endereço" :required="!notRequired"></t-input>
        <t-input cols="2" v-model="address.number" ref="formNumber" label="Número" :required="!notRequired"/>
        <t-input cols="2" v-model="address.complement" label="Compl"/>
      </b-row>

      <b-row>

        <t-input cols="2" v-model="address.provinceAbbreviation" @change="onChangeCountryState"
                 :options="countryStateOptions" label="UF" :required="!notRequired" select-common/>

        <t-input cols="5" v-model="address.cityId" label="Cidade" @search="getCities"
                 :busy="!cityIsLoaded" :options="countryCityOptions" :required="!notRequired" select>
          <template #no-options>
            <span v-if="address.provinceAbbreviation === ''">Selecione um UF</span>
            <span v-else>Cidade não encontrada</span>
          </template>
        </t-input>

        <t-input cols="5" v-model="address.neighborhood" label="Bairro" :required="!notRequired"/>

      </b-row>

    </div>


  </t-form-wrapped>

</template>

<script>
import http from "@/services/config/http-common"

export default {
  name: 'e-address',
  data() {
    return {
      changeDefaultCity: true,
      oldProvinceAbbreviation: "",
      cityIsLoaded: true,
      countryCityOptions: [],
      countryStateOptions: [
        {
          value: "",
          text: "",
          defaultCity: 0
        },
        {
          value: "AC",
          text: "AC - Acre",
          defaultCity: 1200401
        },
        {
          value: "AL",
          text: "AL - Alagoas",
          defaultCity: 2704302
        },
        {
          value: "AM",
          text: "AM - Amazonas",
          defaultCity: 1302603

        },
        {
          value: "AP",
          text: "AP - Amapá",
          defaultCity: 1600303
        },
        {
          value: "BA",
          text: "BA - Bahia",
          defaultCity: 2927408
        },
        {
          value: "CE",
          text: "CE - Ceará",
          defaultCity: 2304400
        },
        {
          value: "DF",
          text: "DF - Distrito Federal",
          defaultCity: 5300108
        },
        {
          value: "ES",
          text: "ES - Espírito Santo",
          defaultCity: 3205309
        },
        {
          value: "GO",
          text: "GO - Goiás",
          defaultCity: 5208707
        },
        {
          value: "MA",
          text: "MA - Maranhão",
          defaultCity: 2111300
        },
        {
          value: "MG",
          text: "MG - Minas Gerais",
          defaultCity: 3106200
        },
        {
          value: "MS",
          text: "MS - Mato Grosso do Sul",
          defaultCity: 5002704
        },
        {
          value: "MT",
          text: "MT - Mato Grosso",
          defaultCity: 5103403
        },
        {
          value: "PA",
          text: "PA - Pará",
          defaultCity: 1501402
        },
        {
          value: "PB",
          text: "PB - Paraíba",
          defaultCity: 2507507
        },
        {
          value: "PE",
          text: "PE - Pernambuco",
          defaultCity: 2611606
        },
        {
          value: "PI",
          text: "PI - Piauí",
          defaultCity: 2211001
        },
        {
          value: "PR",
          text: "PR - Paraná",
          defaultCity: 4106902
        },
        {
          value: "RJ",
          text: "RJ - Rio de Janeiro",
          defaultCity: 3304557
        },
        {
          value: "RN",
          text: "RN - Rio Grande do Norte",
          defaultCity: 2408102
        },
        {
          value: "RO",
          text: "RO - Rondônia",
          defaultCity: 1100205
        },
        {
          value: "RR",
          text: "RR - Roraima",
          defaultCity: 1400100
        },
        {
          value: "RS",
          text: "RS - Rio Grande do Sul",
          defaultCity: 4314902
        },
        {
          value: "SC",
          text: "SC - Santa Catarina",
          defaultCity: 4205407
        },
        {
          value: "SE",
          text: "SE - Sergipe",
          defaultCity: 2800308
        },
        {
          value: "SP",
          text: "SP - São Paulo",
          defaultCity: 3550308
        },
        {
          value: "TO",
          text: "TO - Tocantins",
          defaultCity: 1721000
        }
      ]
    }
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    command: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "address", //Nome do objeto
    },
    notRequired: {
      type: Boolean,
      default: false,
    },
    address: {
      type: Object,
      default: null,
    },
    error: {
      type: Object,
    },
  },
  methods: {


    onChangeCountryState(value) {


      //Reseta para cidade capital se o estado já tivesse sido preenchido
      if (this.oldProvinceAbbreviation !== value && this.changeDefaultCity) {
        //JAMAIS UTILIZAR ESTA OPÇÃO, POIS SE NÃO IRÁ COMPLICAR COM USO DE OUTRAS APIS COMO CNPJWS
        //this.address.cityId = this.countryStateOptions.find(item => item.value === this.address.provinceAbbreviation).defaultCity
      }

      this.changeDefaultCity = true //Libera alteração de cidade padrão novamente
      this.oldProvinceAbbreviation = value

      this.getCities();

    },

    async getCities(name = "") {


      if (this.address.provinceAbbreviation == null || this.address.provinceAbbreviation === '')
        return ""

      this.cityIsLoaded = false

      let params = new URLSearchParams()
      params.set("abbreviation", this.address.provinceAbbreviation)
      params.set("name", name)


      http.list("general/country-city/selectList", params).then((list) => {

        this.countryCityOptions = list
        this.cityIsLoaded = true

      }).catch(error => this.responseError(error))


    },

    setAddress({id, street, province, neighborhood}) {

      const newAddress = {
        street: street,
        provinceAbbreviation: province,
        neighborhood: neighborhood,
        cityId: id
      }

      this.changeDefaultCity = false //Bloqueia alteração para cidade default

      this.$emit("getApi", this.name, newAddress)
      this.$refs.formNumber.$el.getElementsByTagName('input')[0].focus()

    },

  },
  async mounted() {

    if (this.address !== null) {
      this.oldCityId = this.address.cityId
      this.oldProvinceAbbreviation = this.address.provinceAbbreviation
    }

  },
  watch: {
    'address.provinceAbbreviation': {
      handler: async function (after, before) {
        if (after !== undefined && after !== null && after !== before) {

          if (before !== '') {
            this.address.cityId = 0
          }

          await this.getCities()
        }
      },
      deep: true
    }

  }

}
</script>
